// extracted by mini-css-extract-plugin
export default {"container":"EmailDelivery_container__S05Fc","section":"EmailDelivery_section__yH19K","file-info":"EmailDelivery_file-info__rs3KY","email-info":"EmailDelivery_email-info__R9HlC"};